module.exports = __webpack_public_path__ + "img/logo-mutuali.34bf14df.svg";